import axios from "axios";
import { requestInterceptor } from "common-frontend-components";

const axiosInstance = axios.create({
    baseURL: "/api",
});

axiosInstance.interceptors.request.use(requestInterceptor);

export default axiosInstance;
